type useNavigationProps = {
    shopSettings: any,
    mobile?: boolean,
    onClose?: () => void,
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    showCategory: string | boolean,
}

export default function useNavigation({ shopSettings, mobile, onClose, setShowCategory, showCategory }: useNavigationProps) {
    const disableInteractiveVendorList = shopSettings.disableInteractiveVendorList ?? true;

    const getUrl = (i: MenuItem) => {
        if (i.customFields.redirectUrl) return i.customFields.redirectUrl;
        if (i.customFields.interactiveCategoryList) return `/collections/${i.handle}`;
        return `/collections/${i.handle}/products`;
    }

    const setBreadcrumb = (breadcrumb: Breadcrumb[]) => {
        if (mobile && onClose) onClose();
        localStorage.bdcb = JSON.stringify(breadcrumb);
    }

    const onHover = (handle: string) => {
        setShowCategory(handle)
    }

    const onClick = (handle: string, subCategories: MenuItem[]) => {
        if (subCategories != null) {
            if (showCategory != handle) setShowCategory(handle)
            else setShowCategory(false)
        }
    }

    return {
        getUrl,
        setBreadcrumb,
        onHover,
        onClick,
        disableInteractiveVendorList
    }
}